import React, {Component} from 'react';
import Checkbox from "../../elements/components/form/Checkbox";
import {filtersList} from '../filtersList';

export default class AmenitiesFilter extends Component {
    constructor(props) {
        super(props);
        this.handleChangeFilter = this.handleChangeFilter.bind(this);
    }

    handleChangeFilter(name, value) {
        this.props.onChangeFilter({
            [name]: value ? value : undefined
        })
    }

    renderCheckboxes = () => {
        const {translations, checkedAll, disabled} = this.props;

        return filtersList.map((checkbox, index) => {
            return <Checkbox
                key={index}
                name={checkbox['name']}
                label={translations[checkbox['label']]}
                onChange={this.handleChangeFilter}
                checkedAll={checkedAll}
                disabled={disabled}
            />
        })
    }

    render() {
        const {
            translations,
            selectAllAmenities,
            deselectAllAmenities,
            apartmentsCount,
            onClearFilters,
            disabled
        } = this.props;

        return (
            <div className="filter-amenities filter-with-title">
                <div className="search-filters__summary">
                    <h4
                        className="search-filters__clear-filters"
                        onClick={onClearFilters}
                    >
                        Wyczyść filtry
                    </h4>
                    <h3 className="search-filters__score">
                        {apartmentsCount + " " + translations['filters.x-found']}
                    </h3>
                </div>
                <div className="filter-amenities__options-bar">
                    <div className="filter-title">{translations['most-popular-amenities']}</div>
                    <div
                        className="filter-title filter-title--functional"
                        onClick={selectAllAmenities}
                    >
                        {translations['select-all']}
                    </div>
                    <div
                        className="filter-title filter-title--functional"
                        onClick={deselectAllAmenities}
                    >
                        {translations['deselect-all']}
                    </div>
                </div>
                <div className="checkboxes">
                    <Checkbox
                        name="meta[hotelowa-posciel]"
                        label={translations['amenities.hotel-linen']}
                        onChange={this.handleChangeFilter}
                        disabled={this.props.disabled}
                        checked
                        className="disabled"
                    />
                    <Checkbox
                        name="meta[hotelowa-posciel-i-reczniki]"
                        label={translations['amenities.hotel-towels']}
                        onChange={this.handleChangeFilter}
                        checked
                        disabled={this.props.disabled}
                        className="disabled"
                    />
                    {this.renderCheckboxes()}
                </div>
            </div>
        )
    }
}